/* eslint-disable react/require-default-props */
import React from 'react';
import { translate } from '@utils/i18n';
import { TagsList } from '@ui/molecules/TagsList';
import { IssueStatusEnum } from '@features/IIMReview/types';
import { getVariantByStatus } from '@features/IIMReview/utils/statusVariantMapping';
/**
 * Renders the preview tags for an issue card (shown when collapsed)
 * Includes status change tags and correction suggested tag if applicable
 */
export default function IssueTags({ statusChanges, isPreview = false }) {
    // Only render if there are status changes or marked for suggestion
    if (!statusChanges || statusChanges.length === 0) {
        return null;
    }
    const validStatuses = statusChanges === null || statusChanges === void 0 ? void 0 : statusChanges.filter((status) => status !== IssueStatusEnum.Detected);
    return (React.createElement(TagsList, { variant: validStatuses && validStatuses.length > 2 && isPreview ? 'compact' : 'base', tags: [
            ...((validStatuses === null || validStatuses === void 0 ? void 0 : validStatuses.map((statusChange) => ({
                id: statusChange,
                label: translate(statusChange, { namespace: 'features.iim_review.issue_card.status' }),
                variant: getVariantByStatus(statusChange)
            }))) || [])
        ] }));
}
